import {Col, Container, Row} from "react-bootstrap";

export default function Projects() {
    return (
        <Container>
            <Row>
                <Col md={12}>
                    projects
                </Col>
            </Row>
        </Container>
    )
}
